app.factory("ExamsService", ["$http",
    function ($http) {
        var ExamsService = {};

        ExamsService.activationList = function (params) {
            return $http.get("/exams/activation/list", {
                params: {
                    query: params.query,
                    page: params.page || 1,
                    limit: params.limit || 10
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        ExamsService.subjectGroups = function (params) {
            var administratorId = params.administratorId;
            var subjectId = params.subjectId;
            return $http.post("/exams/subject/groups", {
                administratorId: administratorId,
                subjectId: subjectId
            }).then(function (resp) {
                return resp.data;
            });
        };


        ExamsService.selectionList = function (params) {
            var paramsObject = {
                administratorId: params.administratorId,
                subjectId: params.subjectId,
                sessionGroup: params.sessionGroup || null
            };
            return $http.post("/exams/selection/list/", paramsObject).then(function (resp) {
                var data = resp.data;
                var selections = data.subjectSelections;
                var gradeTemplate = data.gradeTemplate;
                var grades = data.grades;
                var subject = data.subject;
                selections.forEach(function (selection) {
                    var finalGradeList = [];
                    var selectionGrades = grades.filter(function (e) {
                        return e.subjectSelection == selection._id
                    });
                    gradeTemplate.components.forEach(function (component) {
                        var cloned = _.cloneDeep(component);
                        if (cloned.type != "group") {
                            var elems = selectionGrades.filter(function (e) {
                                return e.gradeComponent == component._id
                            });
                            if (elems.length > 0) {
                                cloned.grade = elems[0];
                            } else {
                                cloned.grade = null;
                            }
                            cloned.selection = selection._id;
                        }
                        finalGradeList.push(cloned);
                    });

                    finalGradeList.map(function (el) {
                        el.inlineValue = el.grade ? el.grade.absolute : "-";
                    });

                    var masterLayer = finalGradeList.filter(function (e) {
                        return e.parent === null;
                    });
                    masterLayer.map(function (el) {
                        var written = 0;
                        if (el.type == "group") {
                            written = 0;
                            el.items = finalGradeList.filter(function (e) {
                                return e.parent === el._id;
                            });
                            el.inlineValue = _.sumBy(el.items, function (o) {
                                written = written + (o.grade ? 1 : 0);
                                return o.grade ? o.grade.absolute : 0;
                            });
                            el.inlineValue = written > 0 ? Math.round(el.inlineValue * 100) / 100 : "-";

                        }
                    });

                    selection.grades = masterLayer;
                    selection.unorderedGrades = finalGradeList;

                });
                return {subject: subject, selections: selections, gradeTemplate: gradeTemplate};
            });
        };

        ExamsService.addGrade = function (params) {

            var gradeObject = {
                administratorId: params.administratorId,
                gradeComponent: params.gradeComponent,
                relative: params.relative,
                subjectSelection: params.subjectSelection
            };
            return $http.post("/exams/grade/add", gradeObject).then(function (resp) {
                return resp.data;
            });
        };

        ExamsService.editGrade = function (params) {

            var gradeComponentObject = {
                grade: params.grade,
                administratorId: params.administratorId,
                relative: params.relative,
                comment: params.comment
            };
            return $http.post("/exams/grade/edit", gradeComponentObject).then(function (resp) {
                return resp.data;
            });
        };

        ExamsService.editSupportUrl = function (params) {
            return $http.post("/exams/support/url/edit", params).then(function (resp) {
                return resp.data;
            });
        };

        ExamsService.editScheduleUrl = function (params) {
            return $http.post("/exams/schedule/url/edit", params).then(function (resp) {
                return resp.data;
            });
        };

        return ExamsService;
    }
]);
